import React from 'react';
import { BookOpen, Mail, Github, Twitter, Linkedin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto max-w-6xl px-4">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <BookOpen className="h-8 w-8 text-blue-400" />
              <h3 className="text-xl font-bold">ML Course</h3>
            </div>
            <p className="text-gray-400 text-sm">
              Master machine learning from scratch with our comprehensive course. 
              Join thousands of students worldwide.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Github className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Course */}
          <div className="space-y-4">
            <h4 className="font-semibold">Course</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#curriculum" className="hover:text-white transition-colors">Curriculum</a></li>
              <li><a href="#videos" className="hover:text-white transition-colors">Videos</a></li>
              <li><a href="#materials" className="hover:text-white transition-colors">Materials</a></li>
              <li><a href="#qa" className="hover:text-white transition-colors">Q&A</a></li>
            </ul>
          </div>

          {/* Resources */}
          <div className="space-y-4">
            <h4 className="font-semibold">Resources</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors">Documentation</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Code Examples</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Datasets</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Cheat Sheets</a></li>
            </ul>
          </div>

          {/* Support */}
          <div className="space-y-4">
            <h4 className="font-semibold">Support</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors">Help Center</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Community</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Contact Us</a></li>
              <li>
                <a href="mailto:support@mlcourse.com" className="hover:text-white transition-colors flex items-center">
                  <Mail className="h-4 w-4 mr-1" />
                  support@mlcourse.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 ML Course Platform. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};